import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import Spinner from '../../shared/Spinner';
import Loading from '../../shared/Loading';
import Slider from "react-slick";
import EirPhoneCarousel from '../../eir-phone-carousel/EirPhoneCarousel';
import { isMobileOnly } from "react-device-detect";
import EirRadioButton from '../../eir-radio-button/EirRadioButton';
import EirDropdownList from '../../dropdown-list/DropdownList';
import Dom from '../../../utils/Dom';
import Constants from '../../../Constants';
import { currentUser } from '../../../services/CurrentUser';


function EirCustomiseBundleMobile(props) {

    const getOrderDetails = JSON.parse(localStorage.getItem("eir_prequal_order"));
    const OrderBundle = getOrderDetails.bundle;
    const BundleDtls = OrderBundle.mobiles[0];
    const [isLoading, setIsLoading] = useState(true);
    const [isDeviceLoading, setIsDeviceLoading] = useState(false);
    const [spinnerVisible, setSpinnerVisible] = useState(false);
    const orderId = JSON.parse(localStorage.getItem("eir_prequal_order")).id;
    const [phoneDevices, setPhoneDevices] = useState();
    const [filterOptions, setFilterOptions] = useState([]);
    const [APIphoneDevices, setAPIPhoneDevices] = useState();
    const [simOnlySelected, setSimOnlySelected] = useState(true);
    const [phoneSelected, setPhoneSelected] = useState(false);
    const [phoneDeselected, setPhoneDeselected] = useState(false);
    const [portingSelected, setPortingSelected] = useState(false);
    const [phoneSelectedtile, setPhoneSelectedTile] = useState();
    const [handsetSelected, setHandsetSelected] = useState();
    const [customerType, setCustomerType] = useState(localStorage.getItem("global_customer_type").toUpperCase());
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.minified);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.themeMinified);
    const settingsModules = {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: true,
        nextArrow: <CustomArrow />,
        prevArrow: <CustomArrow />
    };
    const mobileSettingsModules = {
        infinite: false,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        className: "center",
        centerMode: true,
        slidesToShow: 1,
    };
    //custom arrow for slides
    function CustomArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, zIndex: "1000" }}
                onClick={onClick}
            > &lt;
            </div>
        );
    }

    // excluding manually 'eir mobile complete' mobile plan 
    const EXCLUDE_R6KEYS = [ "RT_MOBILE_1_60GB" ]
  
    useEffect(() => {
        //console.log("EirCustomiseBundleMobile comp");
        var mobileOrderExists = JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder;
        $(".porting-spinner").addClass("d-none hide")

        /***********Sim only , With Phone radio selection  --- start  ***************/
        setTimeout(() => {
            /* SET SELECTED STATUS BY READING FROM LS (eir_be-data)
            if the orider is empty - by default select the simO - else select the billpay by reading from the eir_be_data 
            */
            // if new order - select the simO by default
            if (mobileOrderExists.length < 1) {
                $(".mobile-step-parent input[type='radio']")[0].click()
                
            } else {
                if (mobileOrderExists[0].plan.simOnly) {
                    //console.log("mobile is being selected");
                    $(".mobile-step-parent input[type='radio']")[0].click()
                    $("#" + (mobileOrderExists[0].plan.id)).addClass("selected");
                    

                }
                else {
                    $(".mobile-step-parent input[type='radio']")[1].click();
                    var selectedHandsetID = mobileOrderExists[0].handset.catalogHandset.id;
                    setTimeout(() => {
                        document.getElementById(selectedHandsetID).click();
                        (mobileOrderExists[0].mobileOrderType === "PORT") ? $('input[name=portingOptions]')[0].click() : $('input[name=portingOptions]')[1].click();
                        $("#" + (mobileOrderExists[0].plan.id)).addClass("selected");
                        /**** display phone cost in page cart-doc */
                        $(".application-page__sidebar__your-mobile-details__total__price__container").removeClass("d-none");
                    }, 2000);

                }
            }
        }, 1000);
        /***********Sim only , With Phone radio selection  --- end  ***************/



        /***********Select the active simo plans ifalready available  --- start  ***************/
        var getSelectedSimoR6Key = (JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder[0] != undefined) ? JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder[0].plan.r6Key : "";
        if ($(".mobile-details-ctr .config-card__card").length > 0) {
            $(".mobile-details-ctr .config-card__card").each(function (e) {
                if ($(this).attr("data-plan-key") == getSelectedSimoR6Key) {
                    $(this).addClass("selected");
                }
            })
        }
        /***********Select the active simo plans ifalready available  --- end  ***************/



        /***********API to get the handsets --- start  ***************/
        (async () => {
            let cusType=JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType;
            if(cusType!="NEW"){
                cusType="FTC";   //As existing billpay phone is calling only with FTC for existing customer
            }
            const rawResponse = await fetch('/store/api/devices/?customerType=' + cusType + '&deviceType=HANDSET&planType=BILLPAY', {
                method: 'GET',
            });
            const resp = await rawResponse.json();
            setAPIPhoneDevices(resp);
            setFilterOptions(getFilterOptions(resp));
            resp.length > 8 ? setPhoneDevices(resp.slice(0, 8)) : setPhoneDevices(resp);
        })();
        /***********API to get the handsets --- end  ***************/
        setIsLoading(false);
        $(".mobile-config").removeClass("d-none");
        $(".hide-for-ui").css("display", "none !important"); // to be removed - for UI dev only

        /***********Select the mobile plans if none selected  --- start  ***************/
        $("#sim-tile-ctr .config-card__button").on("click", function (e) {
            var checkMobilePlanExists = JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder;
            e.stopPropagation();
            //console.log("sim plan btn clicked");
            //console.log(">>>>>>>>>>> ", $(e.target).closest(".config-card__card"));
            //condition to see if card is already selected - if selected , remove it from order
            if ($(e.target).closest(".config-card__card").hasClass("selected")) {
                $(this).next().addClass("d-block"); // show the loader
                setTimeout(() => {
                    config.mobile.api.remove($("#sim-tile-ctr").attr("data-mobile-id"));
                    $(e.target).closest(".config-card__card").removeClass("selected");
                    $(this).next().removeClass("d-block");
                }, 2500);
                return false;
            }
              //hiding phonecost on click of SIMO Plans
            $('input[type=radio][name=mobilePlans]').change(function(e) {
                if(this.value.toLowerCase() == "simonly")
                {
                $(".application-page__sidebar__your-mobile-details__total__price__container").addClass("d-none");
                }
            });
            //simonly plans start ------------------------
            if ($('input[name=mobilePlans]:checked').val().toLowerCase() === "simonly") {
                $(".application-page__sidebar__your-mobile-details__total__price__container").addClass("d-none");
                //console.log("simonly selected -----------------------------");
                var btnReference = e.target.id;
                //console.log("btnReference >>>>>>>>> ", btnReference);
                var newMobilePlanR6Key = e.target.getAttribute("data-plan-id");
                //console.log("0 r6key >>>>>>>>> ", newMobilePlanR6Key);
                e.stopPropagation();
                //console.log("sim plan after stop prop");
                //console.log("newMobilePlanR6Key >>>>>>>> ", newMobilePlanR6Key);
                $(this).addClass("button--disabled");
                config.mobile.api.addSim(newMobilePlanR6Key);
                setTimeout(() => {
                    $(this).removeClass("button--disabled");            
                }, 2000);
            } else {
                //billpay plans start -----------------------------                
                var simTile = $("#sim-tile-ctr .config-card__card ");
                //console.log("billpay selected -----------------------------> ");
                /****** called on click of bill pay tile - start */
                // from SFE -- > this.addBillpayPlan = function (orderId, bundleOfferId, mobilePlanId, deviceId, variantSku, mobileOrderType, callback)
                localStorage.setItem("billpay_selected_plan_id", $(e.target).closest(".config-card__card").attr("data-plan-id"));
                $(this).addClass("button--disabled");   // show loading by disabling select button 
                config.mobile.api.addBillpayPlan(
                    JSON.parse(localStorage.getItem("eir_be_data")).order.id,
                    (JSON.parse(localStorage.getItem("eir_prequal_bundles")).requestedBundle)?JSON.parse(localStorage.getItem("eir_prequal_bundles")).requestedBundle.bundleCode:null,
                    $(e.target).closest(".config-card__card").attr("data-plan-id"),
                    localStorage.getItem("selected_device_id_sku").split("/")[0],
                    localStorage.getItem("selected_device_id_sku").split("/")[1],
                    $('input[name=portingOptions]:checked').val()

                )
                /****** to display the phone cost in cart-doc */
                setTimeout(() => {
                    $(".application-page__sidebar__your-mobile-details__total__price__container").removeClass("d-none");
                    $(this).removeClass("button--disabled");    // hide loading by enabling select button 
                    var phonePriceFromBE = $(".application-page__sidebar__your-mobile-details__total__price").html();
                    $(".selectedPhonePrice").removeClass("priceFrom");
                    if(phonePriceFromBE) {
                        $(".selectedPhonePrice").html((parseInt(phonePriceFromBE.split("€")[1]) > 0) ? phonePriceFromBE : "FREE")
                    }
                }, 4000);

            }
        })

        /***********Select the mobile plans if none selected  --- end  ***************/

    }, []);
    /***********deselect the selected phone  --- start  ***************/

    const deselectPhone = function () {
        $(".billpay-plans-ctr .config-card__card").removeClass("selected");
        $("label").removeClass("radioBtn-selected");
        $(".selectedPhonePrice").html((phoneSelectedtile.fromPrice > 0 ? "&euro;" + phoneSelectedtile.fromPrice : "FREE"))
        $("label").removeClass("purple-border");
        $(".application-page__sidebar__your-mobile-details__total__price__container").addClass("d-none");
        $(".billpay-plans-ctr .mobileRadioTile").removeClass("portingOption-selected");
        setPortingSelected(false);
        setPhoneDeselected(true);

        $(".select-phone").removeClass("d-none").css({ "background": "#fff", "color": "#d111c9", "min-width": "120px", "height": "50px", "margin-bottom": "10px", "padding": "0" });

        $(".selected-phone .tick-icon").addClass("d-none");
        $(".selectedButton").addClass("d-none");

        setTimeout(() => {
            $(".porting-spinner").addClass("d-none");
        }, 2000);


        $(".phone-listing-card.selected-phone").attr("style", "border:0 !important")
        $(".selectedPhonePrice").addClass("priceFrom");
        var mobileOrderExists = JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder;
        if (mobileOrderExists.length > 0) {
            config.mobile.api.remove(mobileOrderExists[0].id);
        }
        localStorage.removeItem("selected_device_id_sku");
    }
    /***********deselect the selected phone  --- end  ***************/

    const getFilterOptions = (devices) => {
        var filterOptions = [{ key: 'all', value: 'All Brands', function: d => true }];

        devices.forEach(device => {
            let key = device.manufacturer.replace(/\s+/g, '').toLowerCase();

            if (filterOptions.filter(option => option.key == key).length == 0) {
                filterOptions.push({
                    key: key,
                    value: device.manufacturer,
                    function: d => d.manufacturer == device.manufacturer
                });
            }
        });

        return filterOptions;
    }

    const selectFilter = (value) => {

        //console.log("=====selected Filter===", value.key.toLowerCase());
        changePhone(value.key.toLowerCase());

    }

    const handleMobileSelection = (e) => {
        var mobileOrderExists = JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder;
        (e.target.value === "simOnly") ?
            (setSimOnlySelected(true), (mobileOrderExists.length > 0) ? setTimeout(() => { $("#" + (mobileOrderExists[0].plan.id)).addClass("selected") }, 1000) : '')
            :
            setSimOnlySelected(false)
        setIsDeviceLoading(true)
        setTimeout(() => {
            setIsDeviceLoading(false);
        }, 1000);
        if (mobileOrderExists.length > 0) {
            setTimeout(() => {
                //console.log("yesssssssss --- ", mobileOrderExists[0]);
                config.mobile.api.remove(mobileOrderExists[0].id);
                $(".application-page__sidebar__your-mobile-details__total__price__container").addClass("d-none");
            }, 1500);
            (e.target.value === "simOnly") ? setSimOnlySelected(true) : setSimOnlySelected(false)
        }
    }

    /****** called on click of porting radio buttons - start */
    const handlePorting = (e) => {
        var priceList;
        setPortingSelected(true);
        $(".mobileRadioTile ").addClass("portingOption-selected"); // adding outline to the porting options tile 
        //console.log("from porting >>>> ", handsetSelected);
        //console.log("from porting >>>> ", handsetSelected);
        (async () => {
            let cusType=JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType;
            if(cusType!="NEW"){
                cusType="FTC";   //As existing billpay phone is calling only with FTC for existing customer
            }
            const rawResponse = await fetch('/store/api/devices/' + handsetSelected + '?customerType=' + cusType + '&planType=BILLPAY', {
                method: 'GET',
            });
            const resp = await rawResponse.json();
            //console.log("resp  from handlePorting >>>> ", resp);
            var selectedPortingOption = ($('input[name=portingOptions]:checked').val()); //set teh value of the selected radio option to fetch the price from pricelist
            //console.log("PortingOptionSelected >>> ", selectedPortingOption);
            priceList = resp.details.prices;
            var setPhonePrice = "";
            for (var i = 0; i < priceList.length; i++) {
                //console.log("portingOptionSelected >>> ", selectedPortingOption);
                if (priceList[i].mobileOrderType == selectedPortingOption) {
                    setPhonePrice = (priceList[i].fromPrice != null) ? priceList[i].fromPrice : priceList[i].price;
                    $(".selectedPhonePrice").html((setPhonePrice > 0 ? "&euro;" + setPhonePrice : "FREE"))
                }
            }
            //console.log("setPhonePrice >>>>>>>>>>>> ", setPhonePrice);
            setTimeout(() => {
                // hide loader coming back from order summary
                $(".porting-spinner").addClass("d-none hide");
            }, 2000);
            //Submit the billpay plan again when porting option changes  and already a plan is selected 
            if (JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder.length > 0) {
                // loader that is shown when already phone selected and changing porting option
                $(".porting-spinner").removeClass("d-none hide");
                config.mobile.api.addBillpayPlan(
                    JSON.parse(localStorage.getItem("eir_be_data")).order.id,
                    (JSON.parse(localStorage.getItem("eir_prequal_bundles")).requestedBundle)?JSON.parse(localStorage.getItem("eir_prequal_bundles")).requestedBundle.bundleCode:null,
                    localStorage.getItem("billpay_selected_plan_id"),
                    localStorage.getItem("selected_device_id_sku").split("/")[0],
                    localStorage.getItem("selected_device_id_sku").split("/")[1],
                    $('input[name=portingOptions]:checked').val()
                )
                setTimeout(() => {
                    // hide loader that is shown when already phone selected and changing porting option
                    $(".porting-spinner").addClass("d-none hide");
                }, 2000);
            }
        })();

    }
    /****** called on click of porting radio buttons - end */
    const renderInnerHTML = function (param, id) {
        var newDivElement = document.createElement('div');
        $("#" + id).html(param);
    }

    const afterPhoneSelected = function (phoneData, variantIndex) {
        $(".select-phone").addClass("d-none");
        $(".selected-phone").attr("style", "border:2px solid #d111c9 !important")
        $(".selectedButton").removeClass("d-none");
        $(".selected-phone .tick-icon").removeClass("d-none");
        setPhoneDeselected(false);
        let selectedVariant = phoneData.variants[variantIndex];
        phoneData.variants = [];
        phoneData.variants.push(selectedVariant);
        setPhoneSelectedTile(phoneData);
        setPhoneSelected(true);
        setHandsetSelected(phoneData.id);
        localStorage.setItem("selected_device_id_sku", phoneData.id + "/" + phoneData.variants[0].sku);
    }


    const changePhone = function (selectedFilter) {
        //remove the already selected phone if any
        var mobileOrderExists = JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder;
        if (mobileOrderExists.length > 0) config.mobile.api.remove(mobileOrderExists[0].id);

        setIsDeviceLoading(true);
        $('input[name=portingOptions]').closest("label").removeClass("purple-border"); // remove the selected class from porting radio
        $('input[name=portingOptions]').closest("label").removeClass("radioBtn-selected"); // remove the selected tick-icon class from porting radio
        $('input[name=portingOptions]').prop('checked', false); // uncheck the portingoptions radio grp
        $(".simPlanCards .config-card__card").removeClass("selected") // remove selected class from the billpay plan tiles
        setPortingSelected(false); // reset the porting radio options
        $(".mobileRadioTile ").addClass("portingOption-selected"); // adding outline to the porting options tile 
        setPhoneSelectedTile(null);
        setPhoneSelected(false);
        //hiding phonecost on clicked of change phone
        $(".application-page__sidebar__your-mobile-details__total__price__container").addClass("d-none");



        setPhoneDevices([]);

        setTimeout(() => {
            if (selectedFilter) {
                let filterFunction = filterOptions.filter(option => option.key.toLowerCase() == selectedFilter).map(option => option.function)[0] || ((d) => true);
                let filteredDevices = APIphoneDevices.filter(filterFunction);
                if (filteredDevices.length < 8 && filteredDevices.length > 4) {
                    for (i = (filteredDevices.length - 1); i < 7; i++) {
                        filteredDevices.push('');
                    }
                }
                setIsDeviceLoading(false);
                APIphoneDevices.length > 8 ? setPhoneDevices(filteredDevices.slice(0, 8)) : setPhoneDevices(filteredDevices);
            }
            else {
                (async () => {
                    let cusType=JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType;
                    if(cusType!="NEW"){
                        cusType="FTC";   //As existing billpay phone is calling only with FTC for existing customer
                    }
                    const rawResponse = await fetch('/store/api/devices/?customerType=' + cusType + '&deviceType=HANDSET&planType=BILLPAY', {
                        method: 'GET',
                    });
                    const resp = await rawResponse.json();
                    setAPIPhoneDevices(resp);
                    setIsDeviceLoading(false);
                    APIphoneDevices.length > 8 ? setPhoneDevices(APIphoneDevices.slice(0, 8)) : setPhoneDevices(APIphoneDevices);
                })();
            }
        }, 1000);
    }

    return (
        <div>
            {isLoading &&
                <Loading className="m-5" />
            }
            <div className={'ap-config__accordion__bellow mobile-config mobile-step-parent ' + ((simOnlySelected) ? 'simPlansCtr' : 'billPayPlansCtr')}>
                <h2 class="BillpayHeading  d-flex justify-content-center align-items-center">
                    Add eir Mobile Billpay</h2>
                <div className="ap-config__accordion__bellow__body d-block">
                    {/* <div className="row">
                        <div className="column large-12 small-12">
                            <div className="alert fill-blue">
                                <div className="row">
                                    <div className="alert__text-column">
                                        <p className="alert__header">We Need Your Attention!</p>
                                        <p className="alert__subtext">You may have made some changes to your original bundle. If you would like to revert click the button.</p>
                                    </div>
                                    <div className="alert__button-column">
                                        <a href="" className="button button--small button--secondary fill-white text-black--light gtm-normal-cta">Update Cart</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* <!-- mobile card 1 --> */}
                    <div id="sim-tile-ctr" className="ap-config__accordion__bellow__body__mobile-product d-block d-none hide-for-ui" data-mobile-id={"none"}>
                        {/* <!-- heading inserted by JS --> */}
                        <div className="ap-config__accordion__bellow__body__mobile-product__heading d-none hide-for-ui">
                            {/* <%--Choose your Mobile Plan for iPhone 6 32GB:--%> */}
                        </div>
                        <div className="ap-config__accordion__bellow__body__mobile-product__config-card">

                            <div className="mobilePlans mb-4">
                                <EirRadioButton
                                    RadioName="mobilePlans"
                                    RadioAriaLabel="Mobile Plans"
                                    handleChange={handleMobileSelection}
                                    Radio1Value={'simOnly'}
                                    Radio2Value={'withPhone'}
                                    Radio1Label={'SIM Only'}
                                    Radio2Label={'With Phone'}
                                    RadioWithStyle={true} >

                                </EirRadioButton>
                            </div>
                            {(!phoneSelected) &&
                                <div className={(simOnlySelected) ? "hide-carousel-section" : "show-carousel-section " + (phoneDevices.length > 8) ? '' : 'w-100'}>
                                    {(!isMobileOnly) &&
                                        <div className="filterDiv mt-5">
                                            <div></div>
                                            <div></div>
                                            <div className="ml-14" >
                                            </div>
                                            {phoneDevices != undefined &&
                                                <div class="sorting-container carousel-filter">
                                                    <EirDropdownList
                                                        options={filterOptions}
                                                        title="BRAND"
                                                        onClick={selectFilter} >
                                                    </EirDropdownList>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {(isMobileOnly) &&
                                        <div>
                                            <div className="carouselHeading d-flex justify-content-center align-items-center mt-5">Choose your phone</div>
                                            {phoneDevices != undefined &&
                                                <div class="d-flex justify-content-center align-items-center carousel-filter mt-4">
                                                    <EirDropdownList
                                                        options={filterOptions}
                                                        title="BRAND"
                                                        onClick={selectFilter} >
                                                    </EirDropdownList>
                                                </div>
                                            }
                                        </div>
                                    }
                                    <div className='content-carousel cc-tile container w-90 m-5'>
                                        {isDeviceLoading &&
                                            <Loading className="m-5" />
                                        }
                                        {(!isDeviceLoading) && (!isMobileOnly) &&
                                            <Slider {...settingsModules} className="d-flex justify-content-center phone-carousel">
                                                {phoneDevices != undefined &&
                                                    phoneDevices.map((tile, index) => (
                                                        <div>
                                                            <EirPhoneCarousel tile={tile} afterPhoneSelected={afterPhoneSelected}></EirPhoneCarousel>
                                                        </div>
                                                    ))}
                                            </Slider>
                                        }
                                        {(!isDeviceLoading) && (isMobileOnly) &&
                                            <Slider {...mobileSettingsModules} className="d-flex justify-content-center phone-carousel">
                                                {phoneDevices != undefined &&
                                                    phoneDevices.map((tile, index) => (
                                                        <div className="w-120">
                                                            <EirPhoneCarousel tile={tile} afterPhoneSelected={afterPhoneSelected}></EirPhoneCarousel>
                                                        </div>
                                                    ))}
                                            </Slider>
                                        }
                                    </div>
                                </div>
                            }
                            <div className={(!simOnlySelected && !phoneSelected) ? "d-none" : "mobile-details-ctr"}>
                                {(phoneSelected) &&
                                    <div className={(simOnlySelected && phoneSelected) ? "d-none" : ""}>
                                        <div className="content-carousel cc-tile phone-carousel phone-selected">
                                            <EirPhoneCarousel tile={phoneSelectedtile} selectedPhoneTile={true} changePhone={changePhone} deselectPhone={deselectPhone} afterPhoneSelected={afterPhoneSelected} ></EirPhoneCarousel>
                                        </div>
                                    </div>
                                }
                                <div className={(!simOnlySelected) ? "billpay-plans-ctr" : ""}>
                                    <Card className={(simOnlySelected || !phoneSelected) ? "d-none" : "mb-4 three_six_card mobileRadioTile col-12"}>
                                        <div className="radioPrefix">
                                            <p className="portingSelection__header">Your phone number</p>
                                            <p className="portingSelection__subtext">Do you want to move your number from another network or get a new eir mobile number?</p>
                                        </div>
                                        <div className={"radio " + ((phoneDeselected) ? "disabled-element" : " ")}>
                                            <EirRadioButton
                                                RadioName="portingOptions"
                                                RadioAriaLabel="Porting Options"
                                                handleChange={handlePorting}
                                                Radio1Value={'PORT'}
                                                Radio2Value={'NEW'}
                                                Radio1Label={'Move your number to eir'}
                                                Radio2Label={'Get a new Number'}
                                                showSelectedIcon={true}>
                                            </EirRadioButton>
                                        </div>
                                        <div className="spinner--animation white porting-spinner d-none hide">
                                            <div className="spinner--block rotateG_01"></div>
                                            <div className="spinner--block rotateG_02"></div>
                                            <div className="spinner--block rotateG_03"></div>
                                        </div>
                                    </Card>
                                    <div className={(simOnlySelected || !phoneSelected) ? "d-none" : "planHeading align-items-center"}>Select your plan</div>
                                    <div className={(simOnlySelected || !phoneSelected) ? '' : 'simPlanCards'}>
                                        {JSON.parse(localStorage.getItem("eir_be_data")).mobilePlans.map((plan, index) => (
                                            (plan.purchasable) &&

                                            <div id={plan.id} className={(plan.simOnly != simOnlySelected || EXCLUDE_R6KEYS.includes(plan.r6Key) ) ? "d-none" :  "config-card__card config-card__card--size-6 config-card-heading config-card-subtext config-card-price config-card-button "} data-plan-type={plan.catalogPlan.planType} data-plan-key={plan.r6Key} data-plan-id={plan.catalogPlan.id}>
                                                <div className={simOnlySelected ? 'sim-ctr' : 'billpay-ctr'}>
                                                    <div className="config-card__inner">
                                                        <div className="config-card__base col-12 mobile-tile">
                                                            {simOnlySelected &&
                                                            
                                                                <div className={"mobile-tile-image float-left eir-h-100 col-5 tile-bg-"+plan.catalogPlan.id }>
                                                                    <span>{plan.name}</span>
                                                                    {/* <img className="hide" src="/opencms/export/sites/default/.galleries/eir/banners/912/billpay_home_bg_1500x800.png" alt="Mobile Bundle" /> */}
                                                                </div>
                                                            }
                                                            <div className={"mobile-tile-copy float-left eir-h-100 " + ((!simOnlySelected) ? "col-12" : "col-7 sim-ctr")}>
                                                                <p className="config-card__heading col-12">{plan.name}</p>
                                                                <div id={"sim-copy-" + index}>
                                                                    {renderInnerHTML(plan.detailsHtml, "sim-copy-" + index)}
                                                                </div>
                                                                <div className="mobile-tile-price-ctr">
                                                                    <div className="euro per-month mobile-tile-price col-8 inline-block price-on-load"><span className="bold">&euro;{(plan.promoHtml != null && plan.promoHtml != "") ? plan.promoHtml.split("|")[0].substring(plan.promoHtml.split("|")[0].indexOf('=') + 1): plan.basePrice}</span><span className="a-month">a month</span><span className={(plan.promoHtml != null && plan.promoHtml != "") ? "afterPrice-billPay-ctr" : "d-none"}>
                                                                        €{(plan.promoHtml != null && plan.promoHtml != "") ? plan.promoHtml.split("|")[1].substring(plan.promoHtml.split("|")[1].indexOf('=') + 1):''} after&nbsp;
                                                                        {(plan.promoHtml != null && plan.promoHtml != "") ? plan.promoHtml.split("|")[2].substring(plan.promoHtml.split("|")[2].indexOf('=') + 1) : ''} months</span></div>
                                                                    <p className="mobile-tile-cta col-4 inline-block cccdddeee">
                                                                        <a id={"mobile-action-button-" + index} className={(!simOnlySelected && !portingSelected) ? "disabled-element config-card__button select " : "config-card__button select "} data-plan-id={plan.r6Key}></a>
                                                                        <div className="spinner__wrapper selected-loader" style={{ position: "absolute", top: "0", left: "0", right: "0", bottom: "0" }}> <div className="spinner--animation ap-fade-in white"> <div className="spinner--block rotateG_01"></div><div className="spinner--block rotateG_02"></div><div className="spinner--block rotateG_03"></div></div></div>
                                                                        <span className="tick-icon"></span>
                                                                        {spinnerVisible &&
                                                                            <Spinner />
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="config-card mobile-details-ctr d-none">
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- mobile card 2 --> */}
                    <div className="ap-config__accordion__bellow__body__mobile-product" data-mobile-id="none">
                        {/* <!-- heading inserted by JS --> */}
                        <div className="ap-config__accordion__bellow__body__mobile-product__heading">
                            {/* <%--Choose your Mobile Plan for iPhone 6 32GB:--%> */}
                        </div>
                        <div className="ap-config__accordion__bellow__body__mobile-product__config-card">
                            <div className="config-card">
                                {/* <!-- plan cards inserted by JS --> */}
                            </div>
                        </div>
                    </div>

                    {/* <!-- mobile card 3 --> */}
                    <div className="ap-config__accordion__bellow__body__mobile-product hide-elem" data-mobile-id="none">
                        {/* <!-- heading inserted by JS --> */}
                        <div className="ap-config__accordion__bellow__body__mobile-product__heading">
                            {/* <%--Choose your Mobile Plan for iPhone 6 32GB:--%> */}
                        </div>
                        <div className="ap-config__accordion__bellow__body__mobile-product__config-card">
                            <div className="config-card">
                                {/* <!-- plan cards inserted by JS --> */}
                            </div>
                        </div>
                    </div>

                    {/* <!-- mobile card 4 --> */}
                    <div className="ap-config__accordion__bellow__body__mobile-product hide-elem" data-mobile-id="none">
                        {/* <!-- Heading inserted by JS --> */}
                        <div className="ap-config__accordion__bellow__body__mobile-product__heading">
                            {/* <%--Choose your Mobile Plan for iPhone 6 32GB:--%> */}
                        </div>
                        <div className="ap-config__accordion__bellow__body__mobile-product__config-card">
                            <div className="config-card">
                                {/* <!-- plan cards inserted by JS --> */}

                            </div>
                        </div>
                    </div>

                    <div>
                    </div>
                </div>
            </div>

        </div >

    );
}
export default EirCustomiseBundleMobile;
